import axios from "axios";
import { API_BASE_URL } from "../../config";

/**
 * Is this recipient already a customer?
 *
 * Asked before a quote goes out, because payment on an existing customer renews
 * or reactivates their subscription rather than opening a second account — and
 * that is a thing the rep should know while they can still change course, not
 * something to discover afterwards.
 */
export const lookupCustomer = async ({ email, mobile }) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/customers/lookup`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("cms_token")}` },
      params: {
        ...(email ? { email } : {}),
        ...(mobile ? { mobile } : {}),
      },
    });
    const body = res.data?.data ?? res.data ?? {};
    return { exists: Boolean(body.exists), customer: body.customer || null };
  } catch {
    /* A lookup that fails must not block a send. The banner is a courtesy; the
       quote is the job. */
    return { exists: false, customer: null };
  }
};
